export const isLocal =
  !process.env.NEXT_PUBLIC_STAGE || process.env.NEXT_PUBLIC_STAGE === 'LOC';
export const isDevelopment = process.env.NEXT_PUBLIC_STAGE === 'DEV' || isLocal;
export const isStage = process.env.NEXT_PUBLIC_STAGE === 'STG';
export const isProduction = process.env.NEXT_PUBLIC_STAGE === 'PRD';
export const googleTagManagerId = process.env.NEXT_PUBLIC_GTM_ID?.trim();
export const shouldLoadGoogleTagManager =
  isProduction &&
  Boolean(googleTagManagerId) &&
  /^GTM-[A-Z0-9]+$/.test(googleTagManagerId ?? '');

export const baseUrl = process.env.NEXT_PUBLIC_BASE_URL as string;
export const assetsUrl =
  process.env.NEXT_PUBLIC_ASSETS_URL?.trim().replace(/\/+$/, '') ||
  'https://cdn-static.zep.us';
export const bakedAvatarAssetsUrl = assetsUrl;
export const zepBaseUrl = process.env.NEXT_PUBLIC_ZEP_BASEURL?.trim();
export const coreBaseUrl =
  process.env.NEXT_PUBLIC_CORE_BASE_URL?.trim() || baseUrl;
export const getBaseUrlWithLocale = (locale: string) =>
  `${process.env.NEXT_PUBLIC_BASE_URL}${locale === 'ko' ? '' : `/${locale}`}`;

/**
 * CMS 미디어 서빙 base URL.
 *
 * ⚠️ `libs/service/apis/src/cms/mediaBaseUrl.ts` 의 `CMS_MEDIA_BASE_URL` 과 **동일 값이
 * 복제돼 있다.** quiz-app 은 `@zep/apis` 에 의존하지 않으므로(그래서 CMS 클라이언트도
 * `src/api/cms/` 에 따로 두고 있다) 상수 하나 때문에 그 패키지를 끌어오지 않는다 —
 * `zepetoful.api` · `schoolSelection.const` 와 같은 기존 관례다.
 * **한쪽을 고치면 반드시 다른 쪽도 고칠 것.**
 *
 * 왜 env 가 아닌 코드 상수인지는 위 파일의 주석 참조(dev/stage/prod 값이 동일).
 */
export const CMS_CDN = 'https://zep.us/cms/media';
